import React from 'react'
import CardContainer from './CardContainer'


export default function CardWide(props) {
  const {
    columns=[],
    className='',
    index,
    gridColsClasses = 'grid-cols-1 md:grid-cols-2 gap-4 p-4',
    alignmentClasses = 'justify-center items-center',
    isCard = false,
  } = props
  const renderBody = () => {
    return (
      <>
      <div className={`grid ${gridColsClasses} ${alignmentClasses}`}>
        {columns.map((column, _index) => {
          const key = `${index}-${_index}`
          return (
            <div key={key} className={`grid ${column.spanClasses}`}>
              {column.content}
            </div>
          )
        })}
      </div>
      </>
    )
  }
  return (
    <>
      <CardContainer
        className={className}
        rounded={false}
        body={renderBody()}
        isCard={isCard}
      />
    </>
  )
}
